import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ChartOptions } from "../../../../../shared/ChartOptions";
import { VIKDashbordClient } from "../../../../../web-api-client";

@Component({
  selector: 'app-vik-total-signals',
  templateUrl: './vik-total-signals.component.html',
  styleUrl: './vik-total-signals.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VIKTotalSignalsComponent implements OnInit, OnChanges {

  @Input() isRefreshed: boolean = false;

  public isLoading: boolean = true;
  public data: ChartOptions | any;

  constructor(public client: VIKDashbordClient, public cdr: ChangeDetectorRef) {


  }

  ngOnInit(): void {
    this.loadData();

  }


  ngOnChanges(changes: SimpleChanges): void {
    // Check if isRefreshed has changed
    if (changes.isRefreshed && changes.isRefreshed.currentValue !== changes.isRefreshed.previousValue) {
      console.log('isRefreshed has changed to:', changes.isRefreshed.currentValue);
      // Perform the reload or the necessary actions here
      this.loadData();
    }
  }

  private loadData() {

    this.isLoading = true;
    let primary_color = localStorage.getItem('primary_color') || '#534686';
    let success_color = localStorage.getItem('success_color') || '#67C100';
    let secondary_color = localStorage.getItem('secondary_color') || '#FFA47A';

    this.client.getTotalSignals().subscribe(r => {

      this.data = {
        data: [],
        series: [
          {
            name: 'Statistics',
            data: r.totalByMont
          },
          {
            name: 'Statistics',
            data: r.totalByMont,
          },
        ],
        chart: {
          type: 'bar',
          height: 100,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '40px',
            borderRadius: 2,
          },
        },
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        states: {
          hover: {
            filter: {
              type: 'darken',
              value: 1,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: [primary_color, '#dad8e0'],
        xaxis: {
          show: false,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        tooltip: {
          marker: {
            show: false,
          },
          fixed: {
            enabled: false,
            position: 'bottomRight',
            offsetX: 0,
            offsetY: 0,
          },
        },
        responsive: [
          {
            breakpoint: 1661,
            options: {
              chart: {
                width: 80,
              },
            },
          },
          {
            breakpoint: 1365,
            options: {
              chart: {
                width: 80,
              },
            },
          },
        ],
        tittle: 'Общо Сигнали',
        icon: 'shopping-bag',
        sale: r.total.toString(),
      };


      this.isLoading = false;
      this.cdr.detectChanges();

    });
  }
}
